<script setup>
// PageLayout — casca padrao de pagina do dashboard.
// Estrutura:
//   <div flex flex-col h-full w-full overflow-hidden>
//     <slot name="header" />          ← opcional (use com <PageHeader>)
//     <div flex-1 min-h-0 overflow-auto :class="bodyPadding">
//       <slot />                       ← conteudo da pagina
//     </div>
//   </div>
//
// Garante: 1 unico container scrollavel (no body), header fixo no topo,
// padding lateral consistente. Combina com `<PageHeader>` mas nao
// depende dele — qualquer header pode ser passado via slot.
defineProps({
  // Padding do container do body. String com classe(s) Tailwind.
  // Default `p-6` casa o padrao das paginas Studio. Use string vazia
  // pra body sem padding (paginas com tabela full-bleed, p.ex.).
  bodyPadding: {
    type: String,
    default: 'p-6',
  },
});
</script>

<template>
  <div class="flex flex-1 flex-col h-full w-full overflow-hidden">
    <slot v-if="$slots.header" name="header" />
    <div class="flex-1 min-h-0 overflow-auto" :class="bodyPadding">
      <slot />
    </div>
  </div>
</template>
